import { render, staticRenderFns } from "./PackersList.vue?vue&type=template&id=0e9f92f0"
import script from "./PackersList.vue?vue&type=script&lang=js"
export * from "./PackersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports